import {
    FILE_INPUT_ACTION, IMG_ACTION, INIT,
    NONE_FILE_DATA_ACTION,
    UPLOAD_ACTION,
    UPLOAD_BUTTON_ACTION,
    UPLOAD_BUTTON_VALIDATION_ACTION
} from './type'

const INITIAL_STATE = {
    cardPhoto: {
        cardNumber: null,
        countryCode: null,
        locale: null,
        fileData: null,
        scheme: null,
        verificationStatus: null,

        showImg: false,
        src: null,
        alt: null,

        upload: false,
        fileValid: false,
    }
}

const cardPhotoReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INIT:
            return {
                ...state,
                cardNumber: action.cardNumber,
                countryCode: action.countryCode,
                scheme: action.scheme,
                locale: action.locale
            }
        case FILE_INPUT_ACTION:
            return {
                ...state,
                fileData: action.fileData,
                fileValid: action.fileValid
            }
        case UPLOAD_ACTION:
            return {
                ...state,
                upload: action.upload
            }
        case UPLOAD_BUTTON_VALIDATION_ACTION:
            return {
                ...state,
                fileValid: action.fileValid
            }
        case UPLOAD_BUTTON_ACTION:
            return {
                ...state,
                upload: action.upload,
                verificationStatus: action.verificationStatus
            }
        case NONE_FILE_DATA_ACTION:
            return {
                ...state,
                fileData: null,
                upload: false
            }
        case IMG_ACTION:
            return {
                ...state,
                showModal: action.showModal,
                src: action.src,
                alt: action.alt
            }
        default:
            return { ...state }
    }
}

export default cardPhotoReducer